import { createReducer, on } from '@ngrx/store';
import {
  setActiveRegion,
  setActiveStore,
  setSpecialismList,
} from '../actions/store-finder.actions';
import {
  BoelsGenericState,
  BoelsPointOfService,
  SpecialismList,
} from '@boels/models';

export interface StoreFinderState extends BoelsGenericState {
  active: BoelsPointOfService | undefined;
  region: string | undefined | null;
  specialism:
    | {
        lang: string;
        specialismList: SpecialismList | undefined;
      }
    | undefined;
}

export const initialState: StoreFinderState = {
  active: undefined,
  region: undefined,
  specialism: undefined,
  error: false,
  loading: false,
  success: false,
};

export const reducer = createReducer(
  initialState,
  on(setActiveStore, (state, { store }) => ({
    ...state,
    active: store,
  })),
  on(setActiveRegion, (state, { region }) => ({
    ...state,
    region,
  })),
  on(setSpecialismList, (state, { lang, specialismList }) => ({
    ...state,
    specialism: { lang, specialismList },
  })),
);
